import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getMotorCCStart,
  getMotorCCSuccess,
  getMotorCCFailure,
} from "../reducers/getMotorCCReducer";
import axios from "axios";
import Cookies from "js-cookie";

export const getMotorCC = createAsyncThunk(
  "getMotorCC",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getMotorCCStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Motor/GetMotorCC`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getMotorCCSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getMotorCCFailure(error.response.data.Message));

      throw error;
    }
  }
);
